import { UserPreference } from 'src/app/models/user-preference';

/**
 * @param inputValue Assumes numerical input of opposite unit of the outputUnit
 * @param outputUnit Unit you wish to convert inputValue into
 * @returns inputValue converted to the outputUnit
 */
export const temperatureUtil = {
  ConvertTemperature: (
    inputValue: number,
    outputUnit: 'fahrenheit' | 'celsius',
    round = false
  ) => {
    if (outputUnit !== 'celsius' && outputUnit !== 'fahrenheit') {
      throw new Error('Expected a valid outputUnit');
    }

    if (outputUnit === 'celsius') {
      let f = inputValue;
      let c = (f - 32) / (9 / 5);
      return round ? Math.round(c) : c;
    } else {
      let c = inputValue;
      let f = c * (9 / 5) + 32;
      return round ? Math.round(f) : f;
    }
  },
  GetUnitSystem: (preferences?: UserPreference[]) => {
    const preference = preferences?.find(
      (pref) => pref?.setting === 'temperatures'
    );
    if (preference) {
      return preference.value as 'imperial' | 'metric';
    }
    return navigator.language === 'en-US' ? 'imperial' : 'metric';
  },
  GetUnit: (
    format: 'text' | 'letter' = 'text',
    preferences?: UserPreference[]
  ): 'celsius' | 'fahrenheit' | string[1] => {
    const unit =
      temperatureUtil.GetUnitSystem(preferences) === 'metric'
        ? 'celsius'
        : 'fahrenheit';

    if (format === 'letter') {
      return unit[0].toUpperCase();
    }
    return unit;
  },
};
